<template>
  <v-app>
    <EscapeHeader />
    <router-view />
    <EscapeFooter />
  </v-app>
</template>

<script>
import EscapeHeader from '@/components/EscapeHeader'
import EscapeFooter from '@/components/EscapeFooter'

export default {
  name: 'App',
  components: {
    EscapeHeader,
    EscapeFooter
  },
}
</script>
